// extracted by mini-css-extract-plugin
module.exports = {"UiMock":"UiMock_UiMock__3mLCS","Banner":"UiMock_Banner__1a1uF","BannerText":"UiMock_BannerText__V26yX"};